module.exports = __webpack_public_path__ + "media/images/lp/lp27-add06032ecbfabb804339a7cf1828252.webp";